import React from 'react';
import PropTypes from 'prop-types';
import './SimpleCard.css';

const SimpleCard = ({ children, title, noBorder, className, headerStyle, style }) => (
  <div
    className={`simple-card ${className}`}
    style={{
      border: noBorder ? '' : '2px solid var(--orsan-blue)',
      ...style,
    }}
  >
    <div className="simple-card-header" style={headerStyle}>
      <h3>{title}</h3>
    </div>
    {children}
  </div>
);

SimpleCard.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  className: PropTypes.string,
  headerStyle: PropTypes.object,
  style: PropTypes.object,
};

SimpleCard.defaultProps = {
  noBorder: false,
  className: '',
  headerStyle: {},
  style: {},
};

export default SimpleCard;
